(function () {
  if (window.__imageOverlayScrollZoom) {
    window.__imageOverlayScrollZoom.initAll();
    return;
  }

  var MOBILE_BREAKPOINT = 960;
  var instances = new WeakMap();

  var isDesktop = function () {
    return window.matchMedia('(min-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  };

  var parsePercent = function (value, fallback) {
    var parsed = parseFloat(String(value).trim());

    return Number.isFinite(parsed) ? parsed : fallback;
  };

  var getViewCoverProgress = function (element) {
    var rect = element.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var scrollRange = viewportHeight + rect.height;

    if (scrollRange <= 0) {
      return 0;
    }

    return Math.max(0, Math.min(1, (viewportHeight - rect.top) / scrollRange));
  };

  var getProgressElement = function (root) {
    var closestSelector = isDesktop()
      ? root.dataset.scrollProgressClosest
      : root.dataset.scrollProgressClosestMobile || root.dataset.scrollProgressClosest;

    if (!closestSelector) {
      return root;
    }

    return root.closest(closestSelector) || root;
  };

  var getIsCoverFit = function (root) {
    return (
      root.classList.contains('image-overlay-scroll-zoom--fit-cover') ||
      root.classList.contains('image-overlay-scroll-zoom--parallax') ||
      (!isDesktop() && root.classList.contains('custom-top-shelf-carousel__promo-card'))
    );
  };

  var getScrollAnimation = function (root) {
    return root.dataset.scrollAnimation === 'parallax' ? 'parallax' : 'zoom';
  };

  var init = function (root) {
    var media = root.querySelector(
      '.image-overlay-scroll-zoom__media:not(.image-overlay-scroll-zoom__media--empty)'
    );

    if (!media) {
      return null;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return null;
    }

    var styles = getComputedStyle(root);
    var zoomStart = parsePercent(styles.getPropertyValue('--image-overlay-scroll-zoom-start'), 130);
    var zoomEnd = parsePercent(styles.getPropertyValue('--image-overlay-scroll-zoom-end'), 100);
    var parallaxStart = parsePercent(styles.getPropertyValue('--image-overlay-scroll-parallax-start'), -35);
    var parallaxEnd = parsePercent(styles.getPropertyValue('--image-overlay-scroll-parallax-end'), 50);
    var scrollAnimation = getScrollAnimation(root);
    var ticking = false;

    var update = function () {
      ticking = false;
      var progress = getViewCoverProgress(getProgressElement(root));

      if (scrollAnimation === 'parallax') {
        var translateY = parallaxStart + (parallaxEnd - parallaxStart) * progress;
        var maxParallaxShift = Math.max(Math.abs(parallaxStart), Math.abs(parallaxEnd));
        var coverScale = 1 + (maxParallaxShift / 100) * 2;

        media.style.backgroundSize = 'cover';
        media.style.transform =
          'translate3d(0, ' + translateY + '%, 0) scale(' + coverScale + ')';
        return;
      }

      var coverFit = getIsCoverFit(root);
      var size = zoomStart + (zoomEnd - zoomStart) * progress;

      if (coverFit) {
        media.style.backgroundSize = 'cover';
        media.style.transform = 'scale(' + size / 100 + ')';
      } else {
        media.style.transform = '';
        media.style.backgroundSize = size + '%';
      }
    };

    var requestUpdate = function () {
      if (ticking) {
        return;
      }

      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();

    return {
      destroy: function () {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);

        media.style.transform = '';
        media.style.backgroundSize = '';
      },
    };
  };

  var destroy = function (root) {
    var instance = instances.get(root);

    if (instance) {
      instance.destroy();
      instances.delete(root);
    }
  };

  var initAll = function (scope) {
    var container = scope || document;

    container.querySelectorAll('[data-image-overlay-scroll-zoom]').forEach(function (root) {
      destroy(root);
      var instance = init(root);

      if (instance) {
        instances.set(root, instance);
      }
    });
  };

  var destroyAll = function (scope) {
    var container = scope || document;

    container.querySelectorAll('[data-image-overlay-scroll-zoom]').forEach(function (root) {
      destroy(root);
    });
  };

  var bootstrap = function () {
    initAll();

    window
      .matchMedia('(min-width: ' + MOBILE_BREAKPOINT + 'px)')
      .addEventListener('change', function () {
        initAll();
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });

  window.__imageOverlayScrollZoom = {
    initAll: initAll,
    destroyAll: destroyAll,
  };
})();
